import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Endereco } from "../pessoa/models/endereco";
import { Cidade } from "./models/cidade";

@Injectable({
    providedIn: 'root'
  })

export class EnderecoService{

    private environmentUrl: string = '';    

    constructor(private httpClient: HttpClient) { this.environmentUrl = environment.ApiCore; }

    getCidades() : Observable<Cidade[]>{
        let url = this.environmentUrl+"/Cidade";        
        return this.httpClient.get<Cidade[]>(url);
    }   

    getEnderecoByPessoa(idPessoa) : Observable<Endereco[]>{
        let url = this.environmentUrl+"/Endereco/Pessoa/"+idPessoa;        
        return this.httpClient.get<Endereco[]>(url);
    } 
}